import { Backend } from './backend';

interface ActiveHeartBeat {
  token: string;
  active_heartbeat: number; // ms
  valid: boolean;
}

interface WaitingHeartBeat {
  token: string;
  position?: string;
  activate_at?: Date;
  queue_heartbeat: number; // ms
  message?: string;
}

export function requestActiveHeartBeat() {
  return Backend.fetchJson<ActiveHeartBeat>('/heartbeat-active.json');
}

export function requestWaitingHeartBeat() {
  return Backend.fetchJson<WaitingHeartBeat>('/heartbeat-waiting.json');
}
